<template>
	<div class="content_list" :class="agentMobile ? 'content_list_lg' : ''" v-loading="loading">
		<div class="normal-list" v-if="listData.length > 0">
			<navCard
				v-for="(item, index) in listData"
				:key="index"
				:navIndex="index"
				:navId="item.id"
				:title="item.type"
				:hospitalName="item.hospital"
				:checkTime="item.time"
				:navType="navType"
				:titTxt="item.diagnose"
				:searchType="searchType"
				@toDetail="getIndex"
			></navCard>
		</div>
		<mescroll-empty v-if="nullFlg" :option="emptyOption"></mescroll-empty>
	</div>
</template>

<script>
// import patApi from '../../api/patient'
import navCard from '../../components/navCard.vue'
import {getPatientInfo} from '../../../../api/appletApi'
import mescrollEmpty from '../../components/mescrollEmpty.vue'
export default {
  name: 'consultation',
  components: {
    navCard,
    mescrollEmpty
  },
  data () {
    return {
      emptyOption: {
        use: true,
        icon: '../static/img/null.png',
        tip: '没有门急诊信息'
      },
      agentMobile: '',
      page: 1,
      pageSize: 10,
      total: 0,

      searchType: 'consultations',
      navType: '8',
      listData: [
        // {
        // 	title: '主诊断名称',
        // 	hospitalName: '鹿城区五马街道社区卫生服务中医院',
        // 	checkTime: '2020/07/15  14:00',
        // 	navType: '8',
        // 	titTxt: '慢性胃炎'
        // }
      ],
      allList: [],
      patId: '',
      nullFlg: false,
      loading: false
    }
  },
  created () {
  },
  mounted (option) {
    /* uni.setNavigationBarTitle({
      title: '门/急诊信息（' + option.patName + '）'
    }) */
    this.patId = this.$route.query.patId
    this.getList()
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      let that = this
      getPatientInfo({
        infoType: 0,
        patId: this.patId
      }).then(data => {
        this.loading = false
        if (data.length == 0) {
          this.nullFlg = true
          return
        }
        let list = data
        list.forEach((item, index) => {
          let info = {
            diagnose: item.linChuangZD,
            hospital: item.yiLiaoJGMC,
            time: item.jiuZhenRQ,
            navType: 8,
            type: item.bingRenXM
          }
          that.listData.push(info)
          that.allList.push(item)
        })
      })
    },
    getIndex (res) {
      let data = this.allList[res]
      this.$router.push({name: 'consultationDetail', params: data})
    }
  }
}
</script>

<style lang="scss" scoped>
.filter_comp_box {
	background-color: #4bcbc3;
}
.normal-list {
	margin-top: 12px;
	padding: 0 12px;
}
.list_none {
	width: 100%;
	text-align: center;
	font-size: 14px;
	color: #666;
	padding: 50px 0;
}
.content_list{
    width: 100%;
    height: 100%;
    background-color: #f6f6f6;
}
</style>



// WEBPACK FOOTER //
// packages/appletView/src/pages/consultations/consultations.vue